import type { DeviceContext } from "../types"

function detectBrowser(ua: string): string {
  if (ua.includes("Firefox/")) {
    const match = ua.match(/Firefox\/([\d.]+)/)
    return `Firefox ${match?.[1] || ""}`
  }
  if (ua.includes("Edg/")) {
    const match = ua.match(/Edg\/([\d.]+)/)
    return `Edge ${match?.[1] || ""}`
  }
  if (ua.includes("Chrome/")) {
    const match = ua.match(/Chrome\/([\d.]+)/)
    return `Chrome ${match?.[1] || ""}`
  }
  if (ua.includes("Safari/") && !ua.includes("Chrome")) {
    const match = ua.match(/Version\/([\d.]+)/)
    return `Safari ${match?.[1] || ""}`
  }
  return "Unknown"
}

function detectOS(ua: string): string {
  if (ua.includes("Mac OS X")) {
    const match = ua.match(/Mac OS X ([\d_]+)/)
    return `macOS ${match?.[1]?.replace(/_/g, ".") || ""}`
  }
  if (ua.includes("Windows NT")) {
    const match = ua.match(/Windows NT ([\d.]+)/)
    const version = match?.[1]
    if (version === "10.0") return "Windows 10/11"
    return `Windows ${version || ""}`
  }
  if (ua.includes("Linux")) return "Linux"
  if (ua.includes("Android")) return "Android"
  if (ua.includes("iOS") || ua.includes("iPhone")) return "iOS"
  return "Unknown"
}

export function captureDeviceContext(): DeviceContext {
  const ua = navigator.userAgent
  const nav = navigator as Navigator & { deviceMemory?: number }

  return {
    url: window.location.href,
    browser: detectBrowser(ua),
    os: detectOS(ua),
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    user_agent: ua,
    memory: nav.deviceMemory || null,
    language: navigator.language,
    cores: navigator.hardwareConcurrency || null,
  }
}
